import { money, fmtDate } from "./order";

// Build a clean order sheet in a new window and trigger the browser print
// dialog — the owner can "Save as PDF" from there. Includes the exact
// print-file list (owner-only), which customers never see.
export function printOrderSheet(order: any, items: any[], files: any[]) {
  const rows = items
    .map(
      (it) => `
      <tr>
        <td>${it.thumbnail ? `<img src="${it.thumbnail}" class="thumb"/>` : ""}</td>
        <td>${esc(it.description)}<div class="muted">${it.kind === "gangsheet" ? "Gang Sheet 28×100cm" : "T-Shirt"}</div></td>
        <td class="num">${it.qty}</td>
        <td class="num">${it.unit_price ? money(it.unit_price) : "—"}</td>
        <td class="num">${it.unit_price ? money(it.unit_price * it.qty) : "—"}</td>
      </tr>`
    )
    .join("");

  const fileRows = files.length
    ? files
        .map(
          (f) =>
            `<li>${esc(f.filename)} <span class="muted">(${Math.round((f.size || 0) / 1024)} KB)</span></li>`
        )
        .join("")
    : "<li class='muted'>No print files attached yet.</li>";

  const delivery =
    order.delivery_method === "pudo"
      ? `Pudo Locker — ${esc(order.locker_name || "")} (${esc(order.locker_code || "")})<br/>Cell: ${esc(order.delivery_phone || "—")}`
      : order.delivery_method === "courier"
      ? `Courier Guy<br/>${esc(order.delivery_address || "—")}<br/>Tel: ${esc(order.delivery_phone || "—")}`
      : "Not specified";

  const html = `<!doctype html><html><head><meta charset="utf-8"/>
  <title>Order ${esc(order.order_number || order.id)}</title>
  <style>
    * { box-sizing: border-box; }
    body { font-family: Arial, Helvetica, sans-serif; color: #111; margin: 32px; }
    h1 { margin: 0; font-size: 22px; }
    .head { display:flex; justify-content:space-between; border-bottom:2px solid #0891b2; padding-bottom:12px; margin-bottom:16px; }
    .brand { color:#0891b2; font-weight:800; font-size:20px; }
    .muted { color:#666; font-size:12px; }
    .grid { display:grid; grid-template-columns:1fr 1fr; gap:16px; margin:16px 0; }
    .box { border:1px solid #ddd; border-radius:8px; padding:12px; }
    .box h3 { margin:0 0 6px; font-size:12px; text-transform:uppercase; letter-spacing:.05em; color:#666; }
    table { width:100%; border-collapse:collapse; margin-top:8px; }
    th, td { text-align:left; padding:8px; border-bottom:1px solid #eee; font-size:13px; vertical-align:middle; }
    th { color:#666; font-size:11px; text-transform:uppercase; }
    .num { text-align:right; }
    .thumb { height:48px; width:48px; object-fit:contain; }
    .total { text-align:right; font-size:18px; font-weight:800; margin-top:8px; }
    .badge { display:inline-block; padding:2px 10px; border-radius:999px; font-size:12px; font-weight:700; }
    .paid { background:#dcfce7; color:#166534; }
    .unpaid { background:#fee2e2; color:#991b1b; }
    ul { margin:6px 0 0; padding-left:18px; }
    @media print { body { margin:12px; } }
  </style></head><body>
    <div class="head">
      <div><div class="brand">CUSTOM T SHIRT BAR</div><div class="muted">DTF Printing • Oudtshoorn</div></div>
      <div style="text-align:right">
        <h1>Order ${esc(order.order_number || "")}</h1>
        <div class="muted">${fmtDate(order.created_at)}</div>
        <div style="margin-top:6px"><span class="badge ${order.payment_status === "paid" ? "paid" : "unpaid"}">${order.payment_status === "paid" ? "PAID" : "UNPAID"}</span></div>
      </div>
    </div>

    <div class="grid">
      <div class="box"><h3>Customer</h3>${esc(order.user_name || "")}<br/><span class="muted">${esc(order.user_email || "")}</span></div>
      <div class="box"><h3>Delivery</h3>${delivery}</div>
    </div>

    <table>
      <thead><tr><th></th><th>Item</th><th class="num">Qty</th><th class="num">Unit</th><th class="num">Total</th></tr></thead>
      <tbody>${rows}</tbody>
    </table>
    <div class="total">${order.quote_amount != null ? "Quote: " + money(order.quote_amount) : ""}</div>

    <div class="grid">
      <div class="box"><h3>Print files (internal)</h3><ul>${fileRows}</ul></div>
      <div class="box"><h3>Notes</h3>${esc(order.customer_note || "—")}${order.admin_note ? `<div class="muted" style="margin-top:6px">Internal: ${esc(order.admin_note)}</div>` : ""}</div>
    </div>
  </body></html>`;

  const w = window.open("", "_blank", "width=900,height=1000");
  if (!w) {
    alert("Please allow pop-ups to print the order sheet.");
    return;
  }
  w.document.write(html);
  w.document.close();
  w.focus();
  setTimeout(() => w.print(), 300);
}

function esc(s: any): string {
  return String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]!));
}
